import { createSelector } from 'reselect'
import { pick } from 'util/objects'

import { selectOnboarding } from '../../selectors'

const defaultAddTeamMembersState = {
  inputMode: 'single',
  emailAddresses: [],
  invitationErrors: null,
}

function selectBase(state) {
  return selectOnboarding(state).addTeamMembers || defaultAddTeamMembersState
}

export function selectInputMode(state) {
  return selectBase(state).inputMode
}

export const selectInvitationErrors = createSelector(
  selectBase,
  base => base.invitationErrors
)

export function selectSingleInputFormFields(state) {
  return pick(
    ['emailAddress0Input', 'emailAddress1Input', 'emailAddress2Input'],
    {
      ...{
        emailAddress0Input: '',
        emailAddress1Input: '',
        emailAddress2Input: '',
      },
      ...selectBase(state),
    },
    true
  )
}

export function selectMultiInputFormFields(state) {
  return pick(
    ['multiEmailAddressInput'],
    { ...{ multiEmailAddressInput: '' }, ...selectBase(state) },
    true
  )
}

export const selectBackPageType = createSelector(
  selectBase,
  base => base.backPageType
)
